<template>
  <div>
    <div class="application12">
      <div class="bannerTemp">
        <bannerTemp :data="bannerData"></bannerTemp>
      </div>
      <module1 :data="a"></module1>
      <module1 :data="b"></module1>
      <module1 :data="c" style="margin-bottom:150px;">
        <div slot="content">
          <div class="list">
            <div>
              <img src="../../assets/images/application/application12-1.jpg" alt />
              <img src="../../assets/images/application/application12-2.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/application/application12-3.jpg" alt />
            </div>
            <div>
              <img src="../../assets/images/application/application12-4.jpg" alt />
            </div>
          </div>
        </div>
      </module1>
    </div>
    <div class="mobile-application12">
      <div class="mobile-bannerTemp">
        <bannerTemp :data="bannerData" :isLong="true"></bannerTemp>
      </div>
      <div class="content">
        <div class="range">
          <div class="part-title">
            业务应用范围
          </div>
          <div class="part-content">
            <p>{{ a.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用概述
          </div>
          <div class="part-content">
            <p>{{ b.p }}</p>
          </div>
        </div>
        <div class="range">
          <div class="part-title">
            业务应用案例
          </div>
          <el-carousel class="carousel" indicator-position="outside" height="18rem" >
            <el-carousel-item>
              <img :src="getImg(`application12-1.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
            <el-carousel-item>
              <img :src="getImg(`application12-2.jpg`)" alt="Carousel Image" style="width: 100%; object-fit: contain;">
            </el-carousel-item>
            <el-carousel-item style="display: flex; justify-content: space-around;">
              <img :src="getImg(`application12-3.jpg`)" alt="Carousel Image" style="width: 50%; object-fit: contain;">
              <img :src="getImg(`application12-4.jpg`)" alt="Carousel Image" style="width: 50%; object-fit: contain;">
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: "Application12",
  metaInfo: {
    title:
      "智慧电网输配电管理信息系统_行业三维可视化应用解决方案-上海臻图信息技术有限公司",
    meta: [
      {
        name: "keywords",
        content:
          "智慧电网,输配电GIS,电力巡检,拉闸分析,电力拓扑分析,电线三维建模,电网三维渲染"
      },
      {
        name: "description",
        content:
          "基于输配电管理/电力规划解决方案,用户可以在电子地图上方便直观地查看杆塔、电缆和变电站等电力设施在空间位置上的分布情况,能够方便直观地实现多元查 询统计、供电范围分析、交叉跨越管理、设备缺陷管理等专业功能,辅助电力运营管理者更好了解电力设施的运营状况,进而做出更好的业务决策。"
      }
    ]
  },
  data() {
    return {
      bannerData: {
        title: "智慧电网输配电管理信息系统",
        p:
          "基于输配电管理/电力规划解决方案，用户可以在电子地图上方便直观地查看杆塔、电缆和变电站等电力设施在空间位置上的分布情况，能够方便直观地实现多元查 询统计、供电范围……"
      },
      a: {
        num: "01",
        name: "业务应用范围",
        p: "电力公司、供电公司的输配电信息化应用。"
      },
      b: {
        num: "02",
        name: "业务应用概述",
        p:
          "基于输配电管理/电力规划解决方案，用户可以在电子地图上方便直观地查看杆塔、电缆和变电站等电力设施在空间位置上的分布情况，能够方便直观地实现多元查 询统计、供电范围分析、交叉跨越管理、设备缺陷管理等专业功能，辅助电力运营管理者更好了解电力设施的运营状况，进而做出更好的业务决策。"
      },
      c: {
        num: "03",
        name: "业务应用案例"
      }
    };
  },
  methods: {
    getImg(fileName) {
      return require(`@/assets/images/application/${fileName}`);
    }
  },
  mounted: function() {}
};
</script>

<style lang="less" scoped>
//scoped
.bannerTemp {
  background-image: url("../../assets/images/other/header_bg.jpg");
}
.application12 {
  .list {
    font-size: 0;
    img {
      width: 100%;
    }
    > div {
      display: inline-block;
      &:nth-child(1) {
        width: 584px;
        margin-right: 20px;
        > img:nth-child(1) {
          margin-bottom: 20px;
        }
      }
      &:nth-child(2) {
        width: 282px;
        margin-right: 20px;
      }
      &:nth-child(3) {
        width: 282px;
      }
    }
  }
}
.mobile-application12 {
  display: none;
  width: 100%;
  flex-direction: column;
  font-family: 'Normal';
  .mobile-bannerTemp {
    width: 100%;
    background-image: url("../../assets/images/other/header_bg.jpg");
    background-position: 30%;
    background-size: cover;
    height: 28rem;
  }
  .content {
    width: 100%;
    font-family: 'Normal';
    .range {
      width: 100%;
      box-sizing: border-box;
      padding: 2rem;
      color: #333333;
      .part-title {
        width: 100%;
        text-align: center;
        font-size: 1.8rem;
        font-weight: bold;
        line-height: 3rem;
      }
      .part-content {
        font-size: 1rem;
        font-weight: 350;
        line-height: 2rem;
        margin-top: 2rem;
        text-indent: 2em;
      }
      .carousel {
        margin-top: 2rem;
      }
    }
  }
}
/deep/.el-carousel__indicators--horizontal  {
  width:100% !important;
  text-align: center !important;
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
/deep/ .el-carousel__button {
  width: 0.5rem;
  height: 0.4rem;
  background: #C1E1FF;
}
/deep/ .case-carousel {
  .is-active {
    .el-carousel__button {
      width: 3rem;
      height: 0.4rem;
      background: #3C80E8;
    }
  }
}
@media (max-width: 1024px) {
  .application12 {
    display: none !important;
  }
  .bannerTemp {
    display: none !important;
  }
  .mobile-application12 { 
    display: flex !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/application/application12.vue